"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Delete = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
require("./Delete.scss");
const Delete_scss_json_1 = __importDefault(require("./Delete.scss.json"));
function Delete({ onClick, }) {
    return ((0, jsx_runtime_1.jsx)("input", { "aria-label": "Delete", className: Delete_scss_json_1.default.deleteButton, onClick: onClick, type: "button", title: "Delete ad" }));
}
exports.Delete = Delete;
//# sourceMappingURL=Delete.js.map